import { patientReferralConstants } from "./PatientReferralConstants";

export const patientReferralReducer = (state = {}, action) => {
  switch (action.type) {
    case patientReferralConstants.REFERRALS_LIST_PROCESSING:
      return {
        ...state,
        referralsProcessing: action.isProcessing
      };
    case patientReferralConstants.REFERRALS_LIST_SUCCESS:
      return {
        ...state,
        referralsList: action.referrals
      };
    case patientReferralConstants.TOTAL_RECORDS_SUCCESS:
      return {
        ...state,
        totalRecords: action.totalRecords
      };
    case patientReferralConstants.REFERRALS_LIST_FAILURE:
      return {
        ...state,
        referralsError: action.error
      };
    default:
      return state;
  }
};
